import type { GuidedQuestion } from "@agentry/zerovia-contracts";
import hearingItemsMarkdown from "../../../../../knowledge/agents/lp-agentry-self/knowledge/hearing-items.md?raw";
import structureTemplatesMarkdown from "../../../../../knowledge/agents/lp-agentry-self/knowledge/structure-templates.md?raw";

export const PACK_HEARING_UCS_ID = "UCS-WEB-001-02-v1";
export const PACK_HEARING_ID = "agents/lp-agentry-self@0.1.0";
export const PACK_HEARING_DISPLAY_NAME = "Agentry 自社 LP";

export type PackHearingDefinition = {
	questions: GuidedQuestion[];
	customPatchDefaults: Record<string, string>;
};

export function parsePackHearing(
	hearingMarkdown: string,
	templatesMarkdown: string,
): PackHearingDefinition {
	const questions: GuidedQuestion[] = [];
	let required = true;
	for (const line of hearingMarkdown.split("\n")) {
		if (line.trim() === "## 任意") required = false;
		const cells = markdownCells(line);
		if (!cells || cells[0] === "id" || cells[0]?.startsWith("---")) continue;
		const [key, prompt, inputLabel = ""] = cells;
		if (!key || !prompt || !/^[a-z][a-z0-9_]*$/.test(key)) continue;
		const selectOptions = prompt.match(/（([^）]+)）/)?.[1];
		questions.push({
			key,
			prompt,
			inputType: inputTypeOf(inputLabel),
			options:
				key === "site" && selectOptions
					? selectOptions.split("/").map((option) => option.trim())
					: [],
			required,
			helpText: null,
		});
	}

	const customPatchDefaults: Record<string, string> = {};
	for (const line of templatesMarkdown.split("\n")) {
		const cells = markdownCells(line);
		if (!cells || !["default", "lp", "newbiz", "creator"].includes(cells[0] ?? "")) continue;
		customPatchDefaults[`audience.${cells[0]}`] = cells[1] ?? "";
	}
	if (questions.length === 0 || Object.keys(customPatchDefaults).length !== 4) {
		throw new Error("Pack hearing markdown does not match the required tables");
	}
	return { questions, customPatchDefaults };
}

function markdownCells(line: string): string[] | null {
	const trimmed = line.trim();
	if (!trimmed.startsWith("|") || !trimmed.endsWith("|")) return null;
	return trimmed
		.slice(1, -1)
		.split("|")
		.map((cell) => cell.trim().replaceAll("`", ""));
}

function inputTypeOf(label: string): GuidedQuestion["inputType"] {
	if (label.includes("選択") || label.includes("確認")) return "SINGLE_SELECT";
	if (label.includes("自由記述")) return "LONG_TEXT";
	return "TEXT";
}

export const packHearing = parsePackHearing(hearingItemsMarkdown, structureTemplatesMarkdown);
